export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";